module.exports = __webpack_public_path__ + "static/img/login_bodian.8ad04cea.png";